module.exports = __webpack_public_path__ + "static/media/blur_how_to_cook_sp.1f006263.png";